/* eslint-disable no-unused-vars */
import { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  ManageCampaignsHeader,
  FilterBar,
  CampaignDisplayList,
  CustomTableHeader,
  GenericContentEvents,
  WelcomeManageCampaigns,
  Loader,
  CellRendererSelector,
  ErrorComponent,
  Search,
  DropDownList,
  SearchBar,
  Table_v2,
} from 'components';
import styled from 'styled-components';
import { Palette } from 'config';
import { Search as SmallSearchIcon } from 'assets/icons';
import { useComputed, useSignal, useSignalEffect } from '@preact/signals-react';
import { getLocalStorageItem, saveLocalStorageItem } from 'utils';

export const CampaignManager_v2 = () => {
  const timePeriodFrom = useSelector((state) => state.manageCampaigns.selectedDateRange.from);
  const timePeriodTo = useSelector((state) => state.manageCampaigns.selectedDateRange.to);

  const selectedCampaigns$ = useSignal(
    new Set(
      getLocalStorageItem({ key: 'tableState', field: 'filteredCampaigns', initialValue: [] }),
    ),
  );

  const selectedStatusFilter$ = useSignal(
    getLocalStorageItem({
      key: 'tableState',
      field: 'statusFilter',
      initialValue: 'allButArchived',
    }),
  );

  return (
    <div style={{ width: '100%', minWidth: '1200px' }}>
      <ManageCampaignsHeader
        isDisabledShowChartBtn={!window.IS_CHART_ACTIVE}
        timePeriod={{ from: timePeriodFrom, to: timePeriodTo }}
      />
      <SearchBar
        selectedCampaigns$={selectedCampaigns$}
        selectedStatusFilter$={selectedStatusFilter$}
      />
      <div
        style={{
          display: 'flex',
          gap: '5px',
          flexWrap: 'wrap',
          marginTop: '5px',
        }}
      >
        {useComputed(() => {
          const camp_ids = Array.from(selectedCampaigns$.value);
          if (selectedStatusFilter$.value !== 'allStatuses') {
            camp_ids.unshift(selectedStatusFilter$.value);
          }
          return camp_ids.map((_camid_status) => <div key={_camid_status}>{_camid_status}</div>);
        })}
      </div>
      <Table_v2
        timePeriodFrom={timePeriodFrom}
        timePeriodTo={timePeriodTo}
        selectedCampaigns$={selectedCampaigns$}
        selectedStatusFilter$={selectedStatusFilter$}
      />
    </div>
  );
};

const WrapComponent = ({ children }) => {
  return <>{children}</>;
};
